import React from 'react';
import { get } from 'lib/comms';
import Table from 'components/Table/Table';
import PromoBannerItem from './PromoBannerItemPage';
import './PromoBanner.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const columns = [
    {
        name: 'Banner',
        grow: 7,
        selector: 'name',
        sortable: true,
        wrap: true,
    },
    { name: 'Active', grow: 2, selector: 'active' },
    {
        name: '',
        selector: 'name',
        sortable: false,
        grow: 0,
        right: true,
        cell: () => <FontAwesomeIcon color="#999" icon={faChevronRight} />,
    },
];

export default class PromoBannerPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            files: [],
            editing: null,
            stepIndex: 0,
        };
    }

    componentDidMount = () => this.reload();

    reload = async () => {
        let resp = await get('cms/promo_banner', null, true);
        if (resp && resp.status === 401) this.setState({ logout: true });
        if (resp && resp.success) {
            this.setState({ data: [resp.data] });
        } else {
            if (resp && resp.status === 404) {
                this.setState({ data: [] });
            } else {
                console.log(resp);
            }
        }
    };

    // update item on change of any item params
    updatePromoBannerItem = (item) => {
        this.setState({
            ...item,
        });
    };

    doneEditing = () => {
        this.setState({ editing: null });
        this.reload();
    };

    render() {
        let { data, search, editing, files, isNew } = this.state;

        return (
            <>
                {this.state.editing ? (
                    <PromoBannerItem
                        promoBannerItem={editing}
                        onBack={this.doneEditing}
                        files={files}
                        updatePromoBannerItem={this.updatePromoBannerItem}
                    />
                ) : (
                    <div className="maincontainer">
                        <h4>Promotional Banner</h4>
                        {!data.length ? (
                            <button
                                className={'btn btn-primary mb-4'}
                                disabled={editing}
                                style={{ float: 'right', right: '10px' }}
                                onClick={() => this.setState({ editing: { id: 'new' } })}
                            >
                                <FontAwesomeIcon icon={faPlusCircle} style={{ marginRight: '10px' }} />
                                ADD NEW BANNER
                            </button>
                        ) : null}
                        <Table
                            columns={columns}
                            data={data}
                            onRowClicked={(item) => this.setState({ editing: item })}
                            tableID="promoBanner"
                            defaultSortField={columns[0].selector}
                        />
                    </div>
                )}
            </>
        );
    }
}
